import { Button } from '@repo/studio-design-system-ui-button'
import type { ButtonSize, ButtonVariant } from '@repo/studio-design-system-ui-button'
import { ChevronLeftIcon } from '@repo/studio-design-system-ui-icons/arrows/chevron-left'
import { ChevronRightIcon } from '@repo/studio-design-system-ui-icons/arrows/chevron-right'
import { tw } from 'utils/classnames'

/** Figma's scrim is 48px wide and coloured by the semantic edge-scrim token. */
export const DEFAULT_SHADOW_COLOR = 'w-12 text-theme_semantic_surface_scrim_content_edge_base-start'

export function EdgeScrim({
  position,
  className,
}: {
  position: 'left' | 'right'
  className?: string
}) {
  return (
    <div
      aria-hidden
      className={tw(
        'pointer-events-none absolute inset-y-0',
        position === 'left' ? 'left-0 bg-scrim-to-r-100' : 'right-0 bg-scrim-to-l-100',
        className,
      )}
    />
  )
}

interface EdgeButtonProps {
  position: 'left' | 'right'
  label: string
  /**
   * The button height used to position the scroll buttons.
   * This may be different from the item height, in order to align the buttons with something
   * specific from the item.
   */
  buttonHeight: number
  buttonVariant: ButtonVariant
  buttonSize: ButtonSize
  onClick: () => void
}

export function EdgeButton({
  position,
  label,
  buttonHeight,
  buttonVariant,
  buttonSize,
  onClick,
}: EdgeButtonProps) {
  return (
    <div
      style={{ height: buttonHeight }}
      className={tw(
        'pointer-events-none absolute top-0 flex items-center',
        position === 'left' ? 'left-0' : 'right-0',
      )}
    >
      <Button
        iconOnly
        aria-label={label}
        variant={buttonVariant}
        size={buttonSize}
        onClick={onClick}
        className="pointer-events-auto mx-5 shadow-studio-shadow-l1"
      >
        {position === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </Button>
    </div>
  )
}
